// eslint-disable-next-line no-undef
const baseUrl = publicPath + modulePath || import.meta.env.VITE_BASE_URL;

const loadFonts = async () => {
  const kenteken = new FontFace('Kenteken', `url(${baseUrl}/fonts/Kenteken.woff2)`);

  try {
    await kenteken.load().then((font) => {
      document.fonts.add(font);
    });
  } catch {
    console.error(`${baseUrl}/fonts/Kenteken.woff2 failed to load`);
  }

  const fontEtelkaLight = new FontFace('Etelka Light Pro', `url(${baseUrl}/fonts/EtelkaLightPro.woff2)`);

  try {
    await fontEtelkaLight.load().then((font) => {
      document.fonts.add(font);
    });
  } catch {
    console.error(`${baseUrl}/fonts/EtelkaLightPro.woff2 failed to load`);
  }

  const fontEtelkaMedium = new FontFace('Etelka Medium Pro', `url(${baseUrl}/fonts/EtelkaMediumPro.woff2)`);

  try {
    await fontEtelkaMedium.load().then((font) => {
      document.fonts.add(font);
    });
  } catch {
    console.error(`${baseUrl}/fonts/fontEtelkaMedium.woff2 failed to load`);
  }
};

export default loadFonts;
